import i18n from '@/lang'

export const loanPurposeVal = [
  {
    val: 40,
    label: i18n.t('Renovasi Rumah')
  },
  {
    val: 41,
    label: i18n.t('Biaya Liburan / Perjalanan')
  },
  {
    val: 42,
    label: i18n.t('Pembelian Barang Elektronik')
  },
  {
    val: 43,
    label: i18n.t('Pembelian Kendaraan')
  },
  {
    val: 44,
    label: i18n.t('Biaya Kesehatan')
  },
  {
    val: 45,
    label: i18n.t('Biaya Pernikahan')
  },
  {
    val: 46,
    label: i18n.t('Keperluan Pribadi Lainnya')
  },
  {
    val: 49,
    label: i18n.t('Belanja Rumah Tangga')
  },
  {
    val: 50,
    label: i18n.t('Biaya Transportasi')
  }
]
